var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { MDS_COLORS_INK_ACCENT } from '@rappi/mustache-b2b-foundations';
import { CopyOutlineIcon, SuccessOutlineIcon } from '@rappi/rests-commons-front';
import { useEffect, useState } from 'react';
import { ButtonStyled } from '../../components/menu-generator-table/styles';
export const CopyToClipboard = (_a) => {
    var { textToCopy } = _a, buttonProps = __rest(_a, ["textToCopy"]);
    const [copied, setCopied] = useState(false);
    const Icon = copied ? SuccessOutlineIcon : CopyOutlineIcon;
    useEffect(() => {
        if (copied) {
            const timeout = setTimeout(() => {
                setCopied(false);
            }, 1000);
            return () => {
                clearTimeout(timeout);
            };
        }
    }, [copied]);
    return (_jsx(ButtonStyled, Object.assign({ onClick: () => {
            setCopied(true);
            void navigator.clipboard.writeText(textToCopy);
        }, iconLeft: _jsx(Icon, { size: 18, color: MDS_COLORS_INK_ACCENT }) }, buttonProps)));
};
